export enum PermissionsLables {
    PriceManagement="Permissions.PriceManagement.Manage",
    ReadBrands="Permissions.Brands.View",
    ManageBrands="Permissions.Brands.Manage",
    ReadRole = "Permissions.Roles.View",
    ManageRole = "Permissions.Roles.Manage",
    ReadCountry = "Permissions.Countries.View",
    ManageCountry = "Permissions.Countries.Manage",
    ReadLanguage = "Permissions.Languages.View",
    CreateLanguage = "Permissions.Languages.Create",
    UpdateLnguage="Permissions.Languages.Update",
    ReadAddress = "Permissions.Addresses.View",
    ManageAddress = "Permissions.Addresses.Manage",
    ReadAreas = "Permissions.Areas.View",
    ManageAraes = "Permissions.Areas.Manage",
    ReadCities = "Permissions.Cities.View",
    ManageCities = "Permissions.Cities.Manage",
    ReadCountries = "Permissions.Countries.View",
    ManageCountries = "Permissions.Countries.Manage",
    ReadNotifications = "Permissions.Notifications.View",
    ManageNotifications = "Permissions.Notifications.Send",
    ReadPermissions = "Permissions.Permissions.View",
    ManagePermissions = "Permissions.Permissions.Manage",
    ReadStreets = "Permissions.Streets.View",
    ManageStreets = "Permissions.Streets.Manage",
    ReadReports = "Permissions.Reports.View",
    ManageReports = "Permissions.Reports.Manage",
    ReadUsers = "Permissions.Users.View",
    ManageUsers = "Permissions.Users.Manage",
    ReadPoints = "Permissions.Points.View",
    ManagePoints = "Permissions.Points.Manage",
    ReadBanner = "Permissions.Banner.View",
    ManageBanner = "Permissions.Banner.Manage",
    ReadCategories = "Permissions.Categories.View",
    ManageCategories = "Permissions.Categories.Manage",
    ReadDiscounts = "Permissions.Discounts.View",
    ManageDiscounts = "Permissions.Discounts.Manage",
    ReadPointCodes = "Permissions.PointCodes.View",
    ManagePointCodes = "Permissions.PointCodes.Manage",
    ReadProducts = "Permissions.Products.View",
    ManageProducts = "Permissions.Products.Manage",
    ReadReviews = "Permissions.Reviews.View",
    ManageReviews = "Permissions.Reviews.Manage",
    ReadBundle = "Permissions.Bundle.View",
    ReviewsReceiveNotification = "Permissions.ReviewsReceiveNotification",
    ReadStores = "Permissions.Stores.View",
    ManageStores = "Permissions.Stores.Manage",
    ReadVariants = "Permissions.Variants.View",
    ManageVariants = "Permissions.Variants.Manage",
    ReadCoupons = "Permissions.Coupons.View",
    ManageCoupons = "Permissions.Coupons.Manage",
    ReadOrders = "Permissions.Orders.View",
    ManageOrders = "Permissions.Orders.Manage",
    OrdersReceiveNotification = "Permissions.Orders.ReceiveNotification",
    OrdersReadPayments = "Permissions.Orders.ViewPayments",
    ReadPaymentTypes = "Permissions.PaymentTypes.View",
    ManagePaymentTypes = "Permissions.PaymentTypes.Manage",
    ReadShippingPreferences = "Permissions.ShippingPreferences.View",
    ManageShippingPreferences = "Permissions.ShippingPreferences.Manage",
    ReadStoreCommissions="Permissions.StoreCommissions.View",
    ManageStoreCommissions="Permissions.StoreCommissions.Manage",
    RecieveNotificationStoreSigningRequests="Permissions.StoreSigningRequests.ReceiveNotifications",
    ReadStoreSigningRequests="Permissions.StoreSigningRequests.View",
    ManageStoreSigningRequests="Permissions.StoreSigningRequests.Manage",
    ReadTaxes = "Permissions.Taxes.View",
    ManageTaxes = "Permissions.Taxes.Manage",
    DeleteLanguage = "Permissions.Languages.Delete",
    ReadGiftCard ='Permissions.GiftCards.View',
    createGiftCard= 'Permissions.GiftCards.Create', 
    updateGiftCard='Permissions.GiftCards.Update', 
    deletegiftCard='Permissions.GiftCards.Delete'

}